export const translations = {
  locale: 'en',
  CallAgentDesktop: {
    HABLAR: '¿Quiere hablar con alguien?',
    SPEAK: 'Want To Speak Live?',
    MOBILESPEAK: 'Want To Speak Live? Click Here!',
    MOBILEHABLAR: '¿Quiere hablar con alguien? ¡Hacer clic aquí!',
    EXPERT: 'Expert Agents Available Now',
    EXPERTO: 'Agentes Expertos Disponibles',
  },
  CallAgentLife: {
    HABLAR: 'Hable con un agente de seguros con licencia',
    SPEAK: 'Speak to a Licensed Insurance Agent',
    EXPERT: 'Agents Available Now',
    EXPERTO: 'Agentes disponibles ahora',
  },
  CallAnAgentMobile: {
    LLAMAR: 'Llamar A Un Agente',
    CALL: 'Call An Agent',
  },
  CallAgent: {
    ACTIVAR: 'Llame Para Activar Una Poliza Ahora',
    ACTIVATE: 'Call to Instantly Activate a Policy',
    'CLICK-SP': 'O haga click para llamar para una activación instantánea:',
    CLICK: 'Or click to call for instant activation:',
  },
  RenderPercentageTracker: {
    INICIO: 'Inicio',
    START: 'Start',
  },
  RenderCompletedPercentage: {
    TERMINADO: 'TERMINADO',
    COMPLETED: 'COMPLETED',
  },
  DidYouKnow: {
    ENCABEZADO: '¿Sabías?',
    HEADER: 'Did you know?',
    ADELANTO: '¡No se requiere pago por adelantado ni CC para la mayoría de las activaciones instantáneas!',
    'UP-FRONT': 'No up-front payment or CC required for most instant activations!',
  },
  NoUpFront: {
    'NO-ADELANTO': '¿Sabía que puede cambiar en cualquier momento de su proveedor de seguro actual sin penalización? Abandone su seguro llamando {{phone}} ahora mismo.',
    'NO-UP-FRONT': 'Did you know you can switch anytime from your current insurance provider with no penalty. So DITCH your insurance by calling {{phone}} right now!',
  },
  TransLookUp: {
    LookUpEN: 'Let us look up this info for you:',
    LookUpSP: 'Permítanos buscar esta información por usted',
  },
  TransLookUpBtnText: {
    BtnTextEN: 'SAVE TIME',
    BtnTextSP: 'Eliminar el 50% de estas preguntas',
  },
  HomeProperties: {
    AÑOCONSTRUCCION: '¿Cuándo Fue Su Vivienda Construida? (Aproximadamente)',
    YEARBUILT: 'When Was Your Home Built? (Approximate)',
    AÑOCONSTRUCCIONRENTA: '¿Cuándo Fue La Vivienda Que Renta Construida? (Aproximadamente)',
    YEARBUILTRENT: "When Was The Property You're Renting Built? (Approximate)",
    OPCIONDEFAULT: '--¿Cuándo Fue Su Vivienda Construida? (Aproximadamente)--',
    DEFAULTOPTIONLABEL: '--When Was Your Home Built? (Approximate)--',
    PIESCUADRADOS: 'Tamaño de la Vivienda (En Pies Cuadrados) ej. 2500',
    SQUAREFEET: 'Size of Home (In Square Feet) ex. 2500',
  },
  DateOfBirth: {
    AVISO: 'Necesitamos saber su edad para encontrar sus mejores opciones de plan.',
    TIP: 'We need to know your age in order to find your best plan options.',
  },
  FormTCPASubmit: {
    ENVIAR: 'Obtén Tu Cotización Gratis',
    SUBMIT: 'GET YOUR FREE QUOTE',
  },
  TYPage: {
    UNIRTE: 'Gracias por unirte a',
    JOIN: 'Thank you for joining',
    TELLAMARAN: 'Alguien te llamará en breve. Por favor revisa tu email para descuentos adicionales.',
    WILLCALLYOU: 'Someone will be calling you shortly. Please check your email for additional discounts.',
  },
  TYOffers: {
    MIENTRAS: 'Mientras espera, también puede hacer clic en al menos 2 resultados de los siguientes para comparar planes y obtener la mejor oferta.',
    WHILEWAIT: 'An agent will contact you shortly. While you wait you can also click on at least 2 results below to compare plans and get the best deal!',
  },
  Footer: {
    RENUNCIA: '{{brand}} es un servicio de referencia de seguros de automóviles de primer nivel que permite a los consumidores '
      + 'de forma rápida y sin esfuerzo solicitar cotizaciones de agencias locales de buena reputación. {{brand}}  no proporciona '
      + 'planes de seguro directamente a los consumidores ni representa a cualquier proveedor específico. {{brand}} conecta a los '
      + 'consumidores con anunciantes y agencias de seguros solo después de que hayamos reunido ciertos criterios de usted. Tenga en '
      + 'cuenta que las tarifas más bajas pueden no estar disponibles en todas las compañías mencionadas. Sus tarifas pueden variar '
      + 'según sus límites de cobertura, deducibles, registros de manejo, tipo de vehículo, ubicación y otras variables.',
    DISCLAIMER: '{{brand}}  is a premier auto insurance referral service which allows consumers to quickly and effortlessly '
      + 'request quotes from reputable local agencies. {{brand}}  does not provide insurance plans directly to consumers nor do '
      + "we represent any specific providers. {{brand}} connects consumers to advertisers and insurance agencies only after we've gathered "
      + 'certain criteria from you. Please note the lowest listed rates may not be available from all companies listed. Your rates may '
      + 'vary based on your coverage limits, deductibles, driving records, type of vehicle, location and other variables.',
  },
  DriverCount: {
    DESCUENTO: 'Si posee más de un vehículo, es elegible para un descuento de multiples autos y podría ahorrar hasta un 20% en su prima de seguro!',
    DISCOUNT: 'If you own more than one vehicle, you are eligible for a multi-car\n'
      + '      discount and could\n'
      + '      save up to 20% on your auto insurance premium!',
    INCAPAZ: 'Parece que no fuimos capaces de recuperar ninguno de tus vehiculos.',
    UNABLE: 'Looks like we weren’t able to pull any of your vehicles.',
    DESPUES: 'Está bien! Podemos añadirlo después.',
    ADDLATER: 'Thats fine! We can add them later.',
  },
  Validation: {
    AÑO: 'Por favor escoja un año válido',
    MARCA: 'Por favor escoja una marca válida',
    MODELO: 'Por favor escoja un modelo válido',
    SUBMODELO: 'Por favor escoja un submodelo válido',
    FIRSTNAME: 'Por favor ingrese nombre',
    LASTNAME: 'Por favor ingrese apellido',
    FECHANAC: 'Por favor ingrese una fecha de nacimiento válida',
    RELACIONCONDUCTOR: '¿Cómo está este conductor relacionado al conductor primario?',
    DIRECCION: 'Por favor ingrese una dirección válida, asegúrese de no añadir ciudad y estado.',
    CIUDAD: 'Por favor ingrese su ciudad.',
    ESTADO: 'Por favor ingrese su estado.',
    CODPOSTAL: 'Por favor ingrese un código postal válido.',
    EMAIL: 'Por favor ingrese un email válido.',
    TELEFONO: 'Por favor ingrese un teléfono válido.',
    DECADA: 'Por favor ingrese la década en que la propiedad fue construida.',
    VIVIENDA: 'Por favor seleccione su tipo de vivienda.',
    PIESCUADRADOS: 'Por favor ingrese los pies cuadrados de su vivienda.',
    PIESCUADRADOSRANGO: 'Los pies cuadrados deben ser de al menos 500 y menos de 10,000',
  },
  SecondVehicle: {
    SEGUNDOVEHICULO: 'No tengo {{vehicles}} vehículos',
    SECONDVEHICLE: "I don't have {{vehicles}} vehicles",
  },
};
